<!-- =========================================================================================
    File Name: ProgramCreate.vue
    Description: Создание новой партнерской программы
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">
        <vs-button @click="activePrompt = true" class="w-full">Новая программа</vs-button>
        <vs-prompt
            title="Создать новую программу"
            cancel-text= "Отменить"
            accept-text= "Создать"
            button-cancel = "border"
            @cancel="clearFields"
            @accept="createProgram"
            @close="clearFields"
            :is-valid="validateForm"
            :active.sync="activePrompt">
            <div>
                <form>

                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-2" placeholder="Название" v-model="programLocal.name" :color="validateForm ? 'success' : 'danger'" />
                            <vs-textarea rows="5" label="Описание" v-model="programLocal.descr" />
                        </div>
                    </div>

                </form>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activePrompt: false,

            programLocal: {
              name: "",
              descr: "",
              state: 1,
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.programLocal.name != ''
        }
    },
    methods: {
        clearFields() {
            Object.assign(this.programLocal, {
              name: "",
              descr: "",
            })
        },
        createProgram() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$store.dispatch('partner/createProgram', Object.assign({}, this.programLocal))
                    this.clearFields()
                }
            })
        }
    },
}
</script>
